<script>
    import TimeUtil from 'util/TimeUtil';
    import { getSender } from 'views/pages/users/feedback/FeedbackUtil';

    export let reply
</script>

<div feedback-id={reply.id} class="reply">
    <div class="header">
        <span class="sender">
            {getSender(reply).name}
        </span>
        <span class="timestamp">
            {TimeUtil.prettyDate(reply.created_at)}
        </span>
    </div>
    <div class="feedback-text">
        {reply.message}
    </div>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.reply {
  padding-left: 32px;
}
.reply .sender {
  color: #122d40;
}

.header {
  margin-bottom: 8px;
  color: rgba(18, 45, 64, 0.5);
}

.timestamp {
  padding-left: 4px;
}

.feedback-text {
  background: hsl(27, 15%, 93%);
  border-radius: 12px 16px;
  padding: 16px;
  display: inline-block;
  margin-bottom: 8px;
}</style>
